var map = {
	"./VLC.png": 5351,
	"./cd.png": 9561,
	"./close.png": 4856,
	"./computerBig.png": 7888,
	"./computerSmall.png": 3461,
	"./credits.png": 3157,
	"./directory.png": 7164,
	"./doomIcon.png": 7937,
	"./forward.png": 9455,
	"./maximize.png": 8104,
	"./miniRT.png": 1202,
	"./minimize.png": 2253,
	"./myComputer.png": 8951,
	"./pause.png": 9908,
	"./play.png": 5028,
	"./rewind.png": 6551,
	"./showcaseIcon.png": 5205,
	"./term.png": 6437,
	"./text.png": 8599,
	"./volumeOff.png": 4149,
	"./volumeOn.png": 5056,
	"./windowExplorerIcon.png": 1569,
	"./windowGameIcon.png": 5756,
	"./windowResize.png": 7188,
	"./windowsStartIcon.png": 8898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;